import type { ComponentPropsWithoutRef } from "react";
import { t } from "@/i18n-js/instance";
import { useBuilderStore } from "@circle-react-shared/BuilderUI";
import { IconButton } from "@circle-react-shared/uikit/HeaderV3/IconButton";

type FullscreenButtonProps = Omit<
  ComponentPropsWithoutRef<typeof IconButton>,
  "name" | "ariaLabel"
>;

export const FullscreenButton = ({
  "aria-label": ariaLabel = t("builder_ui.canvas.enter_fullscreen"),
  title = ariaLabel,
  ...rest
}: FullscreenButtonProps) => {
  const enterFullscreenPreview = useBuilderStore(
    state => state.enterFullscreenPreview,
  );

  const onClickHandler = () => {
    enterFullscreenPreview();
  };

  return (
    <IconButton
      onClick={onClickHandler}
      tooltipText={t("builder_ui.canvas.enter_fullscreen")}
      tooltipPosition="bottom"
      iconSize={20}
      buttonSize={28}
      name="20-builder-ui-website-preview"
      title={title}
      ariaLabel={ariaLabel}
      {...rest}
    />
  );
};
